import * as gqlTypes from "@hydrologiq/gql/graphql"
import { Toggles } from "@hydrologiq/schemas/1.0.0/installationPage"

type Method = "sum" | "max" | "mean" | "min"

export const getQuery = (
  toggles: Toggles | undefined,
  field: string | undefined = undefined,
  method: Method | undefined = undefined
) => {
  switch (method) {
    case "sum":
      return gqlTypes.InstallationPowerAverageDocument
  }

  const peaks = toggles?.peak
  switch (field) {
    case "weight":
      return gqlTypes.InstallationWeightCombinedDocument
    case "power":
      return peaks ? gqlTypes.InstallationPowerCombinedDocument : gqlTypes.InstallationPowerAverageDocument
    default:
      return gqlTypes.InstallationPowerAverageDocument
  }
}

export const getQueryRaw = (
  toggles: Toggles | undefined,
  field: string | undefined = undefined,
  method: Method | undefined = undefined
) => {
  switch (method) {
    case "sum":
      return gqlTypes.InstallationDataWindowedDocument
  }

  const peaks = toggles?.peak
  switch (field) {
    case "weight":
      return gqlTypes.InstallationHydrogenWindowedMwDocument
    case "power":
      return peaks ? gqlTypes.InstallationDataWindowedCombinedDocument : gqlTypes.InstallationDataWindowedDocument
    default:
      return gqlTypes.InstallationDataWindowedDocument
  }
}
